<template>
    <section>
        <compWrapper :title="$t('global.common.base_information', { defaultValue: '基本信息' })" theme="primary">
            <compFormEdit
                class="margin-layout"
                :formdata="getBase"
                ref='formbase'
                v-model="formData"
            ></compFormEdit>
        </compWrapper>
        <compWrapper :title="$t('fbb.organization.carrier_service_list', { defaultValue: '承运商服务列表' })" theme="info">
            <compService class="margin-layout" ref="service"></compService>
        </compWrapper>
        <compWrapper :title="$t('fbb.organization.warehouse_list', { defaultValue: '仓库列表'})" theme="info">
            <compwarehouse
                class="margin-layout"
                ref="warehouse"
            ></compwarehouse>
            <vButtonGroup slot="footer">
				<vButton
					v-for="item in getStatusBtns"
					:key="item.name"
					@click="item.run"
					:theme="item.theme"
				>{{item.name}}</vButton>
			</vButtonGroup>
        </compWrapper>
        <vLoading size="large" transfer :loading="loading"></vLoading>
    </section>
</template>

<script>
import { mapGetters } from "vuex";
import { HttpSaveOrgService } from "@/service/basicdata";
// import mixin from "./mixin";
import compService from "./service";
import compwarehouse from "./warehouse";
export default {
    // mixins: [mixin],
    components: {
        compService,
        compwarehouse
    },
    data() {
        return {
            loading: false,
            type: this.$route.params.type,
            id: this.$route.query.id,
            formData: {
                orgId: this.$route.query.orgId || ""
            }
        };
    },
    computed: {
        ...mapGetters("dictionary", ["getNextOrgList",]),
        isEdit() {
            return this.type === "edit";
        },
        isAdd() {
            return this.type === "add";
        },
        isQuery() {
            return this.type === "query";
        },
        /**
         * 根据状态显示不同按钮
         */
        getStatusBtns() {
            const btn = [
                {
                    name: this.$t('global.common.save', { defaultValue: '保存'}),
                    theme: "primary",
                    show: !this.isQuery,
                    run: this.save
                },
                {
                    name: this.$t('global.common.return', { defaultValue: '返回'}),
                    theme: "default",
                    show: true,
                    run: this.cancel
                }
            ];
            return btn.filter(item => item.show);
        },

        getBase() {
            return [
                {
                    label: this.$t('fbb.alloment.client_organization', { defaultValue: "客户名称"}),
                    key: "orgId",
                    tag: "vSelect",
                    options: this.getNextOrgList,
                    query: !this.isAdd,
                    props:{
                        filterable:true
                    }
                }
            ];
        }
    },
    methods: {
        //更新单据数据
        async save() {
            const valid = await this.$refs.formbase.validate();
            if (!valid) return;
            this.loading = true;
            if (!this.formData.orgCode) {
                const orgId = this.formData.orgId;
                const orgData = this.getNextOrgList.find(item => item.value == orgId)
                this.formData.orgCode = orgData && orgData.attach.code
            }
            if (this.id) this.formData.id = this.id;
            HttpSaveOrgService({
                ...this.formData,
                carrierServiceIds: this.$refs.service
                    ? this.$refs.service.targetKeys
                    : [],
                warehosueIds: this.$refs.warehouse
                    ? this.$refs.warehouse.targetKeys
                    : []
            })
                .then(this.cancel)
                .catch(err => {
                    this.loading = false;
                    this.$VMessage.error(
                        this.$t(err.langCode, { defaultValue: err.message })
                    );
                });
        },
        cancel() {
            this.$router.push({
                name: "basicdataOrganization"
            });
        }
    }
};
</script>
